import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const PolitiqueConfidentialite = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <div className="pt-32 pb-20">
        <div className="max-w-4xl mx-auto px-6">
          <h1 className="text-5xl font-serif font-bold text-[#1a1a1a] mb-12 text-center">
            Politique de confidentialité
          </h1>

          <div className="prose prose-lg max-w-none space-y-8">
            <section>
              <h2 className="text-2xl font-bold text-[#1a1a1a] mb-4">Collecte des données</h2>
              <p className="text-gray-700 mb-4">
                Giletau collecte uniquement les données personnelles nécessaires au bon fonctionnement du site et à la communication avec nos utilisateurs.
              </p>
              <p className="text-gray-700">
                <strong>Données collectées :</strong>
              </p>
              <ul className="space-y-2">
                <li className="text-gray-700">Nom et prénom (formulaire de contact)</li>
                <li className="text-gray-700">Adresse email (formulaire de contact)</li>
                <li className="text-gray-700">Données de navigation (cookies techniques)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#1a1a1a] mb-4">Utilisation des données</h2>
              <p className="text-gray-700 mb-4">
                Les données collectées sont utilisées exclusivement pour :
              </p>
              <ul className="space-y-2">
                <li className="text-gray-700">Répondre à vos demandes via le formulaire de contact</li>
                <li className="text-gray-700">Améliorer l'expérience utilisateur sur le site</li>
                <li className="text-gray-700">Assurer le bon fonctionnement technique du site</li>
              </ul>
              <p className="text-gray-700 mt-4">
                <strong>Nous ne vendons, ne louons ni ne partageons vos données personnelles avec des tiers.</strong>
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#1a1a1a] mb-4">Conservation des données</h2>
              <p className="text-gray-700">
                Les données collectées via le formulaire de contact sont conservées pendant une durée de 3 ans à compter de votre dernier contact, sauf demande de suppression de votre part.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#1a1a1a] mb-4">Vos droits</h2>
              <p className="text-gray-700 mb-4">
                Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez des droits suivants :
              </p>
              <ul className="space-y-2">
                <li className="text-gray-700"><strong>Droit d'accès :</strong> Vous pouvez demander à consulter vos données personnelles</li>
                <li className="text-gray-700"><strong>Droit de rectification :</strong> Vous pouvez demander la correction de vos données</li>
                <li className="text-gray-700"><strong>Droit d'effacement :</strong> Vous pouvez demander la suppression de vos données</li>
                <li className="text-gray-700"><strong>Droit d'opposition :</strong> Vous pouvez vous opposer au traitement de vos données</li>
              </ul>
              <p className="text-gray-700 mt-4">
                Pour exercer ces droits, contactez-nous à : <a href="mailto:contact@giletau.fr" className="text-blue-600 hover:underline cursor-pointer">contact@giletau.fr</a>
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#1a1a1a] mb-4">Sécurité des données</h2>
              <p className="text-gray-700">
                Nous mettons en œuvre toutes les mesures techniques et organisationnelles appropriées pour protéger vos données contre tout accès non autorisé, modification, divulgation ou destruction.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#1a1a1a] mb-4">Modifications</h2>
              <p className="text-gray-700">
                Giletau se réserve le droit de modifier la présente politique de confidentialité à tout moment. Les modifications seront publiées sur cette page avec une date de mise à jour.
              </p>
            </section>

            <section>
              <p className="text-sm text-gray-500 italic">
                Dernière mise à jour : Janvier 2025
              </p>
            </section>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PolitiqueConfidentialite;
